import { useState } from 'react';
import { Search } from 'lucide-react';
import { useMedia, MediaGrid, UploadButton } from '@/admin/media';
import { inputCls } from '@/lib/api';

export default function MediaLibrary() {
  const { items, loading, remove, setItems } = useMedia();
  const [kind, setKind] = useState('all');
  const [q, setQ] = useState('');
  const shown = items.filter((m) => (kind === 'all' || m.kind === kind) && (!q || m.title.toLowerCase().includes(q.toLowerCase())));

  return (
    <div data-testid="admin-media">
      <div className="flex flex-wrap items-center gap-3">
        <div className="me-auto"><h2 className="font-display text-lg font-extrabold text-brand-ink">مكتبة الوسائط</h2>
          <p className="text-xs text-brand-steel">صور (jpg/png/webp/svg/gif) حتى 5MB · ملفات PDF/APK حتى 50MB. انسخ الرابط أو اختر الملف من داخل محرر الصفحات.</p></div>
        {['all', 'image', 'file'].map((k) => (
          <button key={k} onClick={() => setKind(k)} data-testid={`media-filter-${k}`} className={`rounded-full border px-4 py-2 text-xs font-bold ${kind === k ? 'border-brand-blue bg-brand-blue text-white' : 'border-brand-line bg-white text-brand-steel'}`}>
            {k === 'all' ? 'الكل' : k === 'image' ? 'صور' : 'ملفات'}
          </button>
        ))}
        <div className="relative">
          <Search className="absolute start-3.5 top-1/2 h-4 w-4 -translate-y-1/2 text-brand-dim" />
          <input value={q} onChange={(e) => setQ(e.target.value)} data-testid="media-search-input" placeholder="بحث…" className={`${inputCls} !ps-10 w-48 !py-2 !text-xs`} />
        </div>
        <UploadButton onDone={(m) => setItems((xs) => [m, ...xs])} />
      </div>
      <div className="mt-6 rounded-3xl border border-brand-line bg-white p-5">
        {loading ? <p className="py-14 text-center text-sm text-brand-dim">جارٍ التحميل…</p> : <MediaGrid items={shown} onRemove={(id) => { if (window.confirm('حذف الملف نهائياً؟ تأكد أنه غير مستخدم في الموقع.')) remove(id); }} onSelect={() => {}} />}
      </div>
    </div>
  );
}
